import lightTheme from "./lightTheme";
import darkTheme from "./darkTheme";

export const getTheme = (mode) => (mode === "light" ? lightTheme : darkTheme);

export { lightTheme, darkTheme };
